export default __webpack_public_path__ + "static/media/ITRealCase3.a5b5a1ea.jpg";